import { render, staticRenderFns } from "./goodsTags.vue?vue&type=template&id=3c85af76"
import script from "./goodsTags.vue?vue&type=script&lang=js"
export * from "./goodsTags.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports